import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import _c from "classnames";

import _Section from "./Section.js";
import { SectionHeader } from "./../Blocks.js";

import { color, breakpoints } from "./../style/Variables.js";

import ArrowRight from "./img/arrow-right.js";

const Section = styled(_Section)`
  .quote-btn {
    background: none;
    outline: none;
    cursor: pointer;

    path {
      fill: ${color.light_grey};
      transition: fill 0.2s ease;
    }

    &:hover path {
      fill: ${color.turquoise};
    }

    &:focus {
      path {
        fill: ${color.turquoise};
      }
    }
  }

  .quote {
    visibility: visible;
    /*transition: transform 0.6s ease, opacity 0.6s ease; */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    /* min-height: 34em; */

    @media (max-width: 900px) {
      .h4 {
        font-size: 1.625rem;
      }
    }
  }

  .hide-quote {
    opacity: 0;
    transform: translateY(0%);
    visibility: hidden;
  }

  .invisible .hide-quote {
    /* display: none; */
    visibility: hidden;
  }

  /*  .dot {
    width: 6px;
    height: 6px;

    margin: 4px 4px;

    border-radius: 50%;

    &.current {
      transform: scale(1.66);
    }

    transition: transform 0.6s ease;
  }*/
`;

class SectionTestimonials extends React.Component {
  static contextTypes = { copy: PropTypes.object };
  state = { currentQuote: 0 };
  go(v) {
    const copy = this.context.copy.get("SectionTestimonials");
    const quotes = copy ? copy.quotes : [];
    const { currentQuote } = this.state;
    let newIndex = currentQuote + v;
    newIndex = newIndex < 0 ? quotes.length - 1 : newIndex;
    this.setState({
      currentQuote: newIndex % quotes.length,
    });
  }
  renderDots({ quotes }) {
    return quotes.map((q, index) => (
      <Col className="flex justify-center items-center" xs={6} sm={6} md={12}>
        <div
          key={index}
          onClick={() => this.setState({ currentQuote: index })}
          className={_c("dot bg-lg hover-bg-turquoise hover-pointer", {
            current: this.state.currentQuote === index,
          })}
        />
      </Col>
    ));
  }
  renderQuotes({ quotes, invisible }) {
    return quotes.map((q, index) => (
      <div
        key={index}
        className={_c(
          "quote inline-block align-middle justify-center items-center center",
          {
            "absolute top-0 left-0 w-100": !invisible,
            "hide-quote h-0": this.state.currentQuote !== index,
          }
        )}
      >
        <p className="w-100 color-bg font-light h3-s mb2 h4-m">{q.text}</p>
        <div>
          <h5 className="w-100 font-light h7 color-bg pmt1">
            {q.name} aus {q.occupation}
          </h5>
        </div>
      </div>
    ));
  }
  renderButton(v) {
    return (
      <a
        className="border quote-btn fit btn-prev w-100 flex items-center justify-center border-none"
        href="#section-testimonials"
        onClick={evt => {
          if (window.innerWidth > breakpoints[1]) {
            evt.preventDefault();
          }
          this.go(v);
        }}
      >
        <ArrowRight className="fit" reverse={v < 0} />
      </a>
    );
  }
  renderTitle(copy) {
    return (
      <Row>
        <Col>
          <SectionHeader className="color-bluegreen">
            {copy && copy.title}
          </SectionHeader>
        </Col>
      </Row>
    );
  }
  render() {
    const copy = this.context.copy.get("SectionTestimonials");

    // let _quotes = document.getElementsByClassName("quote");

    // let maxHeight = 0;
    // for (let i = 0; i < _quotes.length; ++i) {
    //   const height = _quotes[i].offsetHeight;

    //   if (height > maxHeight) maxHeight = height + 30;
    // }

    // console.log("maxHeight", maxHeight);

    // if (document.querySelector(".invisible"))
    //   document
    //     .querySelector(".invisible")
    //     .setAttribute(`style`, `min-height:${maxHeight}px`);

    return (
      <Section
        id="section-testimonials"
        className="bg-ib relative my4 mmt0"
        style={
          window.innerWidth < 900
            ? {
                marginLeft: "-15px",
                width: "calc(100% + 30px)",
              }
            : {}
        }
      >
        <Row
          className="quote-nav absolute top-0 left-0 w-100 h-100"
          align="center"
          nogutter={true}
        >
          <Col
            className="flex justify-center items-center h-100 z2"
            offset={{ xs: 0 }}
            xs={1.5}
            md={1}
          >
            {this.renderButton(-1)}
          </Col>
          <Col xs={9} md={10}>
            &nbsp;
          </Col>
          <Col
            className="flex justify-center items-center h-100 z2"
            xs={1.5}
            md={1}
          >
            {this.renderButton(1)}
          </Col>
        </Row>
        <Container className="pmx0i">
          <Row
            className="py9 pmy4 pmx0i"
            style={{ marginLeft: "0 !important", marginRight: "0 !important" }}
          >
            <Col className="relative pmx0i pmy3" xs={8} offset={{ xs: 2 }}>
              <div
                className="invisible zx1 no-pointer"
                style={
                  window.innerWidth > 768
                    ? { height: `472px` }
                    : { height: "300px" }
                }
              >
                {copy &&
                  this.renderQuotes({
                    quotes: copy.quotes,
                    invisible: true,
                  })}
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    );
  }
}

export default SectionTestimonials;



// WEBPACK FOOTER //
// ./src/Home/SectionTestimonials.js